import { render, staticRenderFns } from "./BaseConfirmSupport.vue?vue&type=template&id=419156ba&scoped=true&"
import script from "./BaseConfirmSupport.vue?vue&type=script&lang=js&"
export * from "./BaseConfirmSupport.vue?vue&type=script&lang=js&"
import style0 from "./BaseConfirmSupport.vue?vue&type=style&index=0&id=419156ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "419156ba",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('419156ba')) {
      api.createRecord('419156ba', component.options)
    } else {
      api.reload('419156ba', component.options)
    }
    module.hot.accept("./BaseConfirmSupport.vue?vue&type=template&id=419156ba&scoped=true&", function () {
      api.rerender('419156ba', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/global/BaseConfirmSupport.vue"
export default component.exports